import styled from 'styled-components'
import { Icon } from 'antd'

import UserAvatar from 'src/components/UserAvatar'

interface WrapListItemProps {
  integration_type: string
}

const DivCombo = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const DivRoomInfos = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`

const DivUserList = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 32px;
`

const IconPension = styled(Icon)`
  margin-right: 8px;
`

const OfflineOffer = styled.span`
  font-size: small;
  padding: 8px;
`

const WrapAbleUsers = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`

const WrapAvatar = styled(UserAvatar)`
  margin-right: 8px;
`

const WrapListItem = styled.div<WrapListItemProps>`
  background-color: ${({ integration_type }: WrapListItemProps) =>
    integration_type === 'OFFLINE' ? '#cae4ff6b' : '#f7f7f7'};
  border-radius: 4px;
  margin-bottom: 16px;
  padding: 8px;
`

export {
  DivCombo,
  DivRoomInfos,
  DivUserList,
  IconPension,
  OfflineOffer,
  WrapAbleUsers,
  WrapAvatar,
  WrapListItem
}
